'use strict';
module.exports = require('../../full/object/entries');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/features/object/entries.js
// module id = 350
// module chunks = 0